import { PageRoot } from './PageRoot';

export default PageRoot;
